import { TimeZoneNamed } from "@timeedit/registration-schemas";
import { CalendarEvent } from "../../../../utils/events";
import dayjs from "dayjs";

export function TimeColumn({
  events,
  timezone,
}: {
  events: CalendarEvent[];
  timezone: TimeZoneNamed;
}): React.JSX.Element {
  // TODO: Support AM and PM formats?
  return (
    <>
      {events.map(({ start, end, data }, index) => {
        const startDate = dayjs(start).format("HH:mm");
        const endDate = dayjs(end).format("HH:mm");
        return (
          <div
            key={`timeColumn-${data.groupId}-${index}`}
            data-timezoneident={`${timezone.user.identifier}`}
          >
            {startDate} - {endDate} ({timezone.user.extId} {timezone.user.name})
          </div>
        );
      }) ?? []}
    </>
  );
}
